"use client";

import { usePathname } from "next/navigation";
import { SideNav } from "./SideNav";

/**
 * Wraps page children with the global side-nav layout.
 *
 * The lesson page is a focused practice surface (camera + hand-tracking)
 * that already has tight viewport constraints; admin is gated and uses its
 * own header. Auth flows render their own minimal shell. Everywhere else,
 * we add the sidebar + offset the content.
 *
 * Routes here are exact-or-prefix matches against pathname so e.g.
 * `/sign-in/sso-callback` is treated the same as `/sign-in`.
 */
const HIDDEN_PREFIXES = [
    "/lesson",
    "/embed",
    "/admin",
    "/train",
    "/sign-in",
    "/sign-up",
];

function shouldHide(pathname: string): boolean {
    return HIDDEN_PREFIXES.some(
        (p) => pathname === p || pathname.startsWith(p + "/"),
    );
}

export function SideNavGate({ children }: { children: React.ReactNode }) {
    const pathname = usePathname() ?? "/";
    if (shouldHide(pathname)) {
        return <>{children}</>;
    }

    return (
        <div className="app-with-sidenav">
            <SideNav />
            <div className="app-with-sidenav__content">{children}</div>
        </div>
    );
}
